import { RatingOptions } from "@/components/Common/GuidedVideoCall/Steps/QuestionsStep";

type PatientOutcomeRatingsProps = {
  answer: unknown;
  formikProps?: Record<string, unknown>;
  isDisabled?: boolean;
  onRatingClick?: (
    questionSet: string,
    questionId: string,
    optionId: string,
    formikProps: Record<string, unknown>,
  ) => void;
  ratingOptionLabelMap: Record<string, string>;
};

export function PatientOutcomeRatings({
  answer,
  formikProps = {},
  isDisabled = false,
  onRatingClick,
  ratingOptionLabelMap,
}: PatientOutcomeRatingsProps) {
  return (
    <>
      <div className="d-flex justify-content-between">
        {Object.values(ratingOptionLabelMap).map((optionLabel) => (
          <div className="w-100 text-center fs-12 tw:font-bold" key={optionLabel}>
            {optionLabel}
          </div>
        ))}
      </div>

      <RatingOptions
        disabled={isDisabled}
        optionLabelMap={ratingOptionLabelMap}
        optionStyle={{ height: 15 }}
        optionWrapperStyle={{ margin: "0px 5px" }}
        questionData={{ answer }}
        questionId="patient_outcome"
        questionSet="patient_outcome"
        ratingAnswerOnClick={(questionSet: string, questionId: string, optionId: string) =>
          onRatingClick?.(questionSet, questionId, optionId, formikProps)
        }
      />
    </>
  );
}
